import request from '../request'

export const liveApi = {
  // 获取所有直播场次
  getAllLives () {
    return request.get('lives/getAllLives')
  },

  // 创建直播场次
  createLive (data) {
    return request.post('lives/creatLive', data)
  },

  // 更新直播场次
  updateLive (id, data) {
    return request.put(`lives/update/${id}`, data)
  },

  // 删除直播场次
  deleteLive (id) {
    return request.get('lives/deleteById', { params: { liveId: id } })
  },

  // 添加商品到直播
  addToLive (data) {
    return request.post('liveHasGoods/addToLive', data)
  },

  // 从直播中移除商品
  removeFromLive (liveId, itemId) {
    return request.get('liveHasGoods/delete', { params: { liveId, itemId } })
  },

  // 获取直播中的商品
  getLiveGoods (liveId) {
    return request.get('liveHasGoods/findItem', { params: { liveId } })
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/live.js